import { useState, useEffect } from 'react';

export default function useGroupedByLetter(fetchItems, currentLanguage) {
    const [tabList, setTabList] = useState({}); // { 'A': [...genera], 'B': [...] }
    const [activeLetter, setActiveLetter] = useState(null);

    useEffect(() => {
        let _isMounted = true;

        fetchItems().then(response =>{
            if (!_isMounted) return;
            const grouped = {}; // agrupa os gêneros por letra inicial em um objeto hash { 'A': [...], 'B': [...] }
            response.data.forEach(item => {
                const letter = item.name.charAt(0).toUpperCase();
                if (!grouped[letter]) grouped[letter] = []; // cria o bucket se ainda não existe
                grouped[letter].push(item);
            });
            setTabList(grouped); // usa a primeira letra dos dados já ordenados pelo backend
            setActiveLetter(Object.keys(grouped)[0]);
        }).catch(err => console.log(err));

        //acontece quando o componente é desmontado
        return () => {
            _isMounted = false;
        };
    }, [currentLanguage]);

    return { tabList, activeLetter, setActiveLetter };
}